import { Stack } from '@mui/material';
import update from 'immutability-helper';
import { camelCase, has, isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

// Components
import GeneralInformation from 'src/features/CompanyDetail/OverView/GeneralInformation';
import IndustryClassifications from 'src/features/CompanyDetail/OverView/IndustryClassifications';
// import GlobalRanking from 'src/features/CompanyDetail/OverView/GlobalRanking';
import DataSources from 'src/features/CompanyDetail/OverView/DataSources';
import OtherNames from 'src/features/CompanyDetail/OverView/OtherNames';
import RelatedCorporate from 'src/features/CompanyDetail/OverView/RelatedCorporate';
import SkeletonOverview from 'src/features/CompanyDetail/OverView/SkeletonOverview';
import RelatedCompanies from 'src/features/CompanyDetail/OverView/RelatedCompanies';

// Utilities
import { MAX_TIMES_RETRY_GET_DATA, StyledWhiteBox, TypeTabCompany } from 'src/features/CompanyDetail/config';
import { SUCCESS_CODE } from 'src/utils/constants/statusCode';
import { useCheckDataCompanyProcess } from 'src/zustand/useCheckDataCompanyProcess';
import { getArrayDefault } from 'src/utils/helpers/arrayHelpers';
// import DisclaimerAlert from 'src/components/common/DisclaimerAlert';

const OverViewTab = ({
  company,
  // statusFetch,
  isFetching,
  companyFallback,
  // refetch,
}: {
  company: ICompanyDetail;
  companyFallback?: TradeDataCompanyDetail
  // statusFetch: number;
  isFetching: boolean;
  // refetch: () => void;
}) => {
  // const { id = '' } = useParams();
  // const [loadDataFirstTime, setLoadDataFirstTime] = useState(false);
  // const { loadingProcess, dispatch } = useCheckDataCompanyProcess();
  // const isProcessDataChatgpt = !company?.is_chatgpt && isEmpty(company?.industries) && statusFetch === SUCCESS_CODE.GET;
  // const tabName = camelCase(TypeTabCompany.Overview);
  // const isShowLoading =
  //   loadingProcess[id]?.[tabName]?.timeRetry < MAX_TIMES_RETRY_GET_DATA &&
  //   loadingProcess[id]?.[tabName]?.isDone === false &&
  //   isProcessDataChatgpt === true;

  // useEffect(() => {
  //   if (!has(loadingProcess, `${id}.${tabName}`)) {
  //     const newLoadingProcess = update(loadingProcess, {
  //       $set: {
  //         [id]: {
  //           ...loadingProcess[id],
  //           [tabName]: {
  //             timeRetry: 0,
  //             isDone: false,
  //           },
  //         },
  //       },
  //     });
  //     dispatch(newLoadingProcess);
  //   }
  // }, []);

  // useEffect(() => {
  //   // After fetch data done first time
  //   if (isFetching === false && loadDataFirstTime === false) {
  //     setLoadDataFirstTime(true);
  //   }
  // }, [isFetching]);

  // useEffect(() => {
  //   if (
  //     loadingProcess[id]?.[tabName]?.timeRetry === MAX_TIMES_RETRY_GET_DATA ||
  //     (isFetching === false && !isProcessDataChatgpt)
  //   ) {
  //     const newLoadingProcess = update(loadingProcess, {
  //       $set: {
  //         [id]: {
  //           ...loadingProcess[id],
  //           [tabName]: {
  //             timeRetry: MAX_TIMES_RETRY_GET_DATA,
  //             isDone: true,
  //           },
  //         },
  //       },
  //     });
  //     dispatch(newLoadingProcess);
  //     return;
  //   } else {
  //     const intervalId = setInterval(() => {
  //       const newLoadingProcess = update(loadingProcess, {
  //         $set: {
  //           [id]: {
  //             ...loadingProcess[id],
  //             [tabName]: {
  //               timeRetry: loadingProcess[id]?.[tabName]?.timeRetry + 1,
  //               isDone: false,
  //             },
  //           },
  //         },
  //       });
  //       dispatch(newLoadingProcess);
  //       refetch();
  //     }, 10000);
  //     return () => clearInterval(intervalId);
  //   }
  // }, [isProcessDataChatgpt, loadingProcess[id]?.[tabName]?.timeRetry]);

  // if (isFetching && !loadDataFirstTime) {
  if (isFetching) {
    return <SkeletonOverview />;
  }

  return (
    <React.Fragment>
      <Stack spacing={3}>
        {/* <DisclaimerAlert
          title="Data Loading and Usage Guidelines"
          content={
            <Typography variant="body1" align="left">
              Due to the extensive data volume, some information may require up to 5 seconds to load. We recommend that
              users either wait for the full dataset to appear or review available data. Please note that while much of
              the presented data is sourced directly from reliable sources, some information may vary in accuracy. Users
              are advised to interpret and use all information with care and discretion.
            </Typography>
          }
        /> */}
        <Stack direction="row" spacing={3}>
          <StyledWhiteBox flex={1}>
            <GeneralInformation dataCompanyFallback={companyFallback} dataCompany={company} />
          </StyledWhiteBox>
          <StyledWhiteBox flex={1}>
            <IndustryClassifications
              dataCompany={company}
              // isShowLoading={isShowLoading}
            />
          </StyledWhiteBox>
        </Stack>
        <OtherNames dataCompany={company} />
        <RelatedCompanies />
        <RelatedCorporate />
        {/*{getArrayDefault(company?.data_source).length > 0 && (*/}
        {/*  <StyledWhiteBox>*/}
        {/*    <DataSources dataCompany={company} />*/}
        {/*  </StyledWhiteBox>*/}
        {/*)}*/}
        {/* <GlobalRanking dataCompany={company} /> */}
      </Stack>
    </React.Fragment>
  );
};

export default OverViewTab;
